import React from 'react';

const VainillaDialogV2 = (props) => {
    const {
        tipo = 'success',
        show = false,
        title,
        body,
        funct,
        respYes = 'Aceptar',
        respNot,
        size = 'm',
        data = {}
    } = props;

    // Use values from props.data if available
    const finalTipo = data.tipo ?? tipo;
    const finalShow = data.show ?? show;
    const finalTitle = data.title ?? title;
    const finalBody = data.body ?? body;
    const finalFunct = data.funct ?? funct;
    const finalRespYes = data.respYes ?? respYes;
    const finalRespNot = data.respNot ?? respNot;
    const finalSize = data.size ?? size;

    // Ensure the size is valid
    const validSizes = ['s', 'm', 'l', 'xl'];
    const sizeClass = validSizes.includes(finalSize.toLowerCase()) ? finalSize.toLowerCase() : 'm';
    const sizes = {
        's': 'col-lg-3 p-5',
        'm': 'col-lg-5 p-4',
        'l': 'col-lg-7 p-4',
        'xl': 'col-lg-9 p-3'
    };

    // Determine the text color based on the tipo
    const titleClass = finalTipo.toLowerCase() === 'success' ? 'h2 text-green4' :
        finalTipo.toLowerCase() === 'warning' ? 'h2 text-warning' :
            finalTipo.toLowerCase() === 'error' ? 'h2 text-danger' : 'h2 text-dark';

    return (
        <div className={"contenedor dosis " + (finalShow && (finalBody || finalTitle) ? "vw-100 vh-100 blur-l bg-white6" : "hide")} style={{ position: "fixed", top: 0, left: 0, zIndex: 999 }}>
            <div className="row justify-content-center w-100 p-1 m-0">
                <div className={`${sizes[sizeClass]} shadow rounded text-center text-dark  bg-white mt-5`}>
                    {finalTitle && <p className={titleClass}>{finalTitle}</p>}
                    {finalBody && <p className="col-log-12 h6 text-300 mt-4 mb-4" style={{ maxHeight: '600px', minHeight: '80px', overflow: 'auto' }}>{finalBody}</p>}
                    <div className="row justify-content-center">
                        <div className="col-lg-6 text-center">
                            <button
                                className="btn btn-light border border-danger shadow mt-3 round-xl"
                                onClick={() => { if (finalFunct) finalFunct(true); }}>{finalRespYes}</button>
                        </div>
                        {finalRespNot && (
                            <div className="col-lg-6 text-center">
                                <button
                                    className="btn btn-light shadow mt-3 border border-info round-xl"
                                    onClick={() => { if (finalFunct) finalFunct(false); }}>{finalRespNot}</button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VainillaDialogV2;
